module.exports = __webpack_public_path__ + "static/media/bundle_bg_C.19d5d63d.png";